import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import {
  WebSocketClient,
  createWebSocketClient,
} from 'studio5/clients/websocket';
import { useAuth } from './auth';

const WSContext = createContext<WebSocketClient | null>(null);

export default function WebSocketProvider({
  children,
}: PropsWithChildren<unknown>) {
  // eslint-disable-next-line @appcues/use-context-hooks-in-provider
  const { client: authClient } = useAuth();

  const wsClient = useMemo(() => {
    return createWebSocketClient(authClient);
  }, [authClient]);

  // Handle cleanup when the provider unmounts
  useEffect(() => {
    return () => {
      wsClient.client.dispose();
    };
  }, [wsClient]);

  return <WSContext.Provider value={wsClient}>{children}</WSContext.Provider>;
}

export function useWebSocket() {
  const wsClient = useContext(WSContext);

  if (!wsClient) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }

  return wsClient;
}
